export const link1 = 'https://canva.link/4nf7v1vlik0c8im';
export const link2 = 'https://canva.link/u9gwfpcsw2xt8wq';
export const link3 = 'https://canva.link/mvxclbkswvgj14e';
export const link4 = 'https://canva.link/1te4e8fw5c9pgid';
export const link5 = 'https://canva.link/h4t1aer51lns1if';
